import { BaseModel, fillOwnProperties } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'
import { toCroppedImage } from '~/shared/utils/image'

export default class CareerRoutesDetailSkillItem extends BaseModel {
  static override constructorName = 'CareerRoutesDetailSkillItem'

  name: string = ''
  image: string = ''

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data)

      this.image = toCroppedImage(data.image)
    }
  }
}
